// setup methods for external use of Axios
import axios from 'axios';
import { Api, baseURL, headers } from 'Utils/api';
import { Buffer } from 'buffer';

// Create a custom instance, without the withCredentials attribute.  AWS doesn't like it
const instance = axios.create({
  baseURL,
  headers,
  withCredentials: false,
});

interface Options {
  bucket?: string;
  contentType?: string;
  expires?: string;
  visibility?: string;
  headers?: any;
  options?: any;
  cancelToken?: any;
  progress?: (progress: number) => void;
}
export const awsStore = async (file: any, binaryFileString: any, options: Options = {}) => {
  // Use our api to get a response from our backend.
  // const optionStore = { progress: () => {}, ...options };
  const response = await Api.post(
    import.meta.env.VITE_VAPOR_URL,
    {
      bucket: options?.bucket || '',
      content_type: options?.contentType || file.type,
      expires: options?.expires || '',
      visibility: options?.visibility || '',
    },
    {
      baseURL: null,
      headers: options?.headers || {},
      ...options?.options,
    }
  );

  const headers = response.data.headers;

  if ('Host' in headers) {
    delete headers.Host;
  }

  const cancelToken = options.cancelToken || '';
  const fileName = file.name.trim();

  // Find the last period, so we can get the extension of the file
  const lastPeriod = fileName.lastIndexOf('.');

  // Handle files without an extension
  let fileExtension = '';
  let name = fileName;
  if (lastPeriod !== -1) {
    fileExtension = fileName.slice(lastPeriod);
    name = fileName.slice(0, lastPeriod);
  }

  let dataToSend;
  if (fileExtension.toLowerCase() === '.pdf') {
    dataToSend = file;
  } else {
    dataToSend = Buffer.from(binaryFileString.replace(/^data:image\/\w+;base64,/, ''), 'base64');
  }

  // Build the config for the PUT request
  const putConfig: any = {
    cancelToken,
    headers,
    uuid: response.data.uuid,
    key: response.data.key,
    bucket: response.data.bucket,
    name: fileName,
    extension: fileExtension,
    content_type: file.type,
  };

  // Add upload progress callback if provided
  if (options.progress) {
    putConfig.onUploadProgress = (progressEvent: any) => {
      options.progress(progressEvent.loaded / progressEvent.total);
    };
  }

  // Send the file and update it's data on AWS
  await instance.put(response.data.url, dataToSend, putConfig);

  response.data.name = name;
  response.data.extension = fileExtension;
  response.data.file = fileName;

  return response.data;
};
